import { NmsWizardStepModel } from "@nms-angular-toolkit/nms-wizard";
import { SlotData } from "../1-ends/end-step-circuit-dwdm.model";
import { CircuitChangesCallbacks, CircuitChangeToBeApplied } from "../../../dwdm-circuit.model";

/**
 * Representa o modelo do step Links do DwdmCircuitWizard.
 */
export class LinksStepModel extends NmsWizardStepModel {

    constructor() {
        super()
        this.links = [];
    }

    aEndResourceId: number;
    aEndUseMux: boolean;
    aEndMuxResourceId?: number;
    zEndResourceId: number;
    zEndUseMux: boolean;
    zEndMuxResourceId?: number;
    intermediatesResourceIds: Array<number>;
    links: LinkInfoCircuit[];
}

/**
 * Representa o modelo de Link adicionado ao Circuito DWDM.
 */
export class LinkInfoCircuit {
    id: number;
    name: string;
    aEndResourceId: number;
    aEnd: string;
    aEndTransmission: string;
    aEndPortModel: string;
    zEndResourceId: number;
    zEnd: string;
    zEndTransmission: string;
    zEndPortModel: string;
    distance?: string;
    attenuation?: string;
    situation: string;
    status: string;
    identifier: string;
    description: string;
}

/**
 * Recurso utilizados para filtrar os possíveis Links de um Circuito.
 */
export interface CircuitLinksFilterResources {
    aEndResourceId: number;
    zEndResourceId: number;
    aEndSlots: SlotData[];
    zEndSlots: SlotData[];
    intermediatesResourceIds: number[];
    aEndMuxResourceId: number;
    zEndMuxResourceId: number;
}

export interface DwdmCircuitSlotData {
    slotNo: string;
    chassisNo: string;
    slotModel: string;
    slotName: string;
    ports: DwdmCircuitPortData[];
}

export interface DwdmCircuitPortData {
    portNo: string;
    portModel: string;
    portName: string;
    slotNo: string;
    chassisNo: string;
    deviceResourceId: number;
}

/**
 * Modelo de validação utilizado no passo links.
 */
export interface LinksValidatorData {
    linkIds: Array<number>;
    intermediatesResourceIds: Array<number>;
    aEndResourceId: number;
    zEndResourceId: number;
    aEndMuxResourceId: number;
    zEndMuxResourceId: number;
}


/**
 * Define as possíveis alterações que o usuário pode fazer no passo de Links.
 */
export type LinksChanges = "addLinks" | "removeLink" | "removeAllLinks";

/**
 * Tipo que define uma mudança que o usuário realizou no passo de Links.
 *
 * Contém o nome da alteração e os valores necessários para
 * realizar a alteração no momento apropriado.
 */
export type LinksChangesToBeApplied = CircuitChangeToBeApplied<LinksChanges>;


/**
 * Define as ações que devem ser realizadas para aplicar cada mudança possível no passo de Links.
 */
export type LinksChangesCallbacks = CircuitChangesCallbacks<LinksChanges>;
